import { matchesNestedKeyword } from '../../shared/utils/keyword-filter';
import { Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { DecimalPipe } from '@angular/common';
import { PageTitleService } from '../../core/services/page-title.service';
import { StudioService } from '../../core/services/studio.service';
import { ProductService } from '../../core/services/product.service';
import { StudioSelectionService } from '../../core/services/studio-selection.service';
import { AuthStateService } from '../../core/services/auth-state.service';
import { PagerComponent } from '../../shared/components/pager.component';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';

const SESSION_KEY = 'product_select_studio_id';

const PRODUCT_TYPES = [
  { id: 0, name: 'その他' }, { id: 1, name: '月会費' },
  { id: 2, name: '入会金・事務手数料' }, { id: 3, name: 'ロッカー費' },
  { id: 4, name: 'PT費' }, { id: 5, name: '物販' },
];

function productTypeName(id: number): string {
  return PRODUCT_TYPES.find(t => t.id === id)?.name ?? String(id);
}

@Component({
    selector: 'app-product-list',
    imports: [RouterLink, FormsModule, DecimalPipe, PagerComponent, FlashMessageComponent],
    template: `
<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-list"></i> 一覧 <span>(全 {{filteredItems.length}} 件)</span></span>
        </div>
        <div class="card-body">
          <div class="row"><app-flash-message class="col-md-12"></app-flash-message></div>
          <form novalidate name="myForm">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label" for="studio_name">店舗</label>
                    <select class="form-control" id="studio_name" name="studio_name"
                      [(ngModel)]="selectedStudio" (ngModelChange)="onStudioChange()">
                      <option [ngValue]="null">-- 選択してください --</option>
                      @for (studio of studios; track studio.id) {
                        <option [ngValue]="studio">{{studio.name}}</option>
                      }
                    </select>
                  </div>
                </div>
              </div>
            </div>
            @if (showFilterOption) {
              <div class="row" style="align-items: flex-end;">
                <div class="col-md-8">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label class="col-form-label" for="keyword">キーワード検索</label>
                      <input id="keyword" name="keyword" type="text" [ngModel]="keyword" (ngModelChange)="keyword = $event; pageIndex = 0"
                        class="form-control" placeholder="商品名、備考など">
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <button class="btn btn-warning text-white" type="button" (click)="keyword=''; pageIndex=0">
                        <i class="fa s-icon-backspace fa-fw"></i>&nbsp;条件クリア
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            }
          </form>
          <hr>
        </div>
        <div class="card-body">
          <div class="form-group row">
            <div class="col-md-12">
              <a class="btn btn-primary text-white" routerLink="/product/new">
                <i class="fa s-icon-plus fa-fw"></i>&nbsp;新規作成
              </a>
            </div>
          </div>
          @if (filteredItems.length === 0) {
            <span>該当するデータはありません</span>
          }
          @if (filteredItems.length > 0) {
            <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
            <table class="table table-bordered table-sm table-hover table-ptb-0">
              <thead>
                <tr>
                  <th width="10%">状態</th>
                  <th width="18%">店舗名</th>
                  <th width="10%">商品種別</th>
                  <th width="18%">商品名</th>
                  <th width="10%">金額</th>
                  <th width="10%">備考</th>
                  <th width="14%"></th>
                </tr>
              </thead>
              <tbody>
                @for (item of pagedItems; track item.id) {
                  <tr>
                    <td class="text-center">
                      @if (+item.status === 0) {
                        <button class="btn text-green p-0 bg-inherit active" type="button" (click)="setStatus(item, 1)">
                          <i class="fa fa-3x fa-toggle-on"></i>
                        </button>
                      }
                      @if (+item.status === 1) {
                        <button class="btn text-secondary bg-inherit p-0 active" type="button" (click)="setStatus(item, 0)">
                          <i class="fa fa-3x fa-toggle-off"></i>
                        </button>
                      }
                    </td>
                    <td>{{item.studio?.name}}</td>
                    <td>{{productTypeName(item.productType)}}</td>
                    <td>{{item.name}}</td>
                    <td class="text-right">{{taxIncluded(item)}}</td>
                    <td>{{item.note}}</td>
                    <td class="text-center">
                      <a class="mt-1 mb-1 btn btn-primary btn-sm text-white"
                        [routerLink]="['/product', item.id, 'edit']" title="編集">
                        <i class="fa s-icon-edit fa-fw"></i>
                      </a>
                      @if (+item.status === 0) {
                        <button class="mt-1 mb-1 btn btn-secondary btn-sm text-white" type="button" disabled>
                          <i class="fa s-icon-delete fa-fw"></i>
                        </button>
                      }
                      @if (+item.status === 1) {
                        <button class="mt-1 mb-1 btn btn-danger btn-sm" type="button"
                          (click)="openDeleteModal(item)">
                          <i class="fa s-icon-delete fa-fw"></i>
                        </button>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
            <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
          }
        </div>
      </div>
    </div>
  </div>
</div>

@if (showDeleteModal) {
  <div class="modal-backdrop fade show"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content border-danger">
        <div class="modal-header bg-danger">
          <h5 class="modal-title">商品の削除</h5>
          <button type="button" class="close" (click)="showDeleteModal = false">
            <span class="text-white" aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="background-color: #FFF6F8 !important">
          <div class="form-group row">
            <label class="col-md-12 col-form-label">商品を削除します。よろしいですか。</label>
          </div>
        </div>
        <div class="modal-footer" style="background-color: #FFF6F8 !important">
          <button class="btn bg-close text-white" type="button" (click)="showDeleteModal = false">
            <i class="fa s-icon-cancel fa-fw"></i>&nbsp;閉じる
          </button>
          <button class="btn btn-danger" type="button" (click)="deleteProduct()">
            <i class="fa s-icon-delete"></i>&nbsp;削除
          </button>
        </div>
      </div>
    </div>
  </div>
}
  `
})
export class ProductListComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private studioService = inject(StudioService);
  private productService = inject(ProductService);
  private studioSelection = inject(StudioSelectionService);
  private authState = inject(AuthStateService);

  studios: any[] = [];
  selectedStudio: any = null;
  items: any[] = [];
  keyword = '';
  private loadRevision = 0;
  showFilterOption = false;
  showDeleteModal = false;
  selectedProduct: any = null;
  readonly pageLimit = 300;
  pageIndex = 0;

  readonly productTypeName = productTypeName;

  taxIncluded(item: any): string {
    const rate = item.taxRate?.rate ?? 0;
    const amount = Math.floor(item.amount + item.amount * rate);
    return '¥' + amount.toLocaleString('ja-JP', { maximumFractionDigits: 0 });
  }

  get filteredItems(): any[] {
    return this.items.filter(item => matchesNestedKeyword(item, this.keyword));
  }

  get pagedItems(): any[] {
    return this.filteredItems.slice(this.pageIndex * this.pageLimit, (this.pageIndex + 1) * this.pageLimit);
  }

  get totalPages(): number {
    return Math.ceil(this.filteredItems.length / this.pageLimit);
  }

  goToPage(p: number): void {
    this.pageIndex = Math.max(0, Math.min(p, this.totalPages - 1));
  }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('商品マスター', 's-icon-list');
    this.studios = await this.studioService.list('all') ?? [];
    const restored = this.studioSelection.restore(this.studios, SESSION_KEY);
    if (this.studios.length === 1) {
      this.selectedStudio = this.studios[0];
      await this.loadProducts();
    } else if (restored) {
      this.selectedStudio = restored;
      await this.loadProducts();
    } else {
      await this.loadProducts();
    }
  }

  async onStudioChange(): Promise<void> {
    ++this.loadRevision;
    this.items = [];
    this.showFilterOption = false;
    this.pageIndex = 0;
    if (!this.selectedStudio) {
      this.studioSelection.clear(SESSION_KEY);
    } else {
      this.studioSelection.save(this.selectedStudio, SESSION_KEY);
    }
    await this.loadProducts();
  }

  private async loadProducts(): Promise<void> {
    const revision = ++this.loadRevision;
    const studioIds = this.selectedStudio?.id
      ?? ((this.authState.currentUser?.role ?? 99) <= 20
        ? this.studios.map(studio => studio.id).join(',')
        : '');
    if (!studioIds) return;
    try {
      const items = await this.studioService.getProduct(studioIds) ?? [];
      if (revision !== this.loadRevision) return;
      this.items = items;
      this.showFilterOption = this.items.length > 0;
    } catch {
      if (revision !== this.loadRevision) return;
      this.showFilterOption = false;
    }
  }

  async setStatus(item: any, status: number): Promise<void> {
    await this.productService.upsert({ id: item.id, status });
    item.status = status;
  }

  openDeleteModal(item: any): void {
    this.selectedProduct = item;
    this.showDeleteModal = true;
  }

  deleteProduct(): void {
    if (!this.selectedProduct) return;
    this.productService.remove(this.selectedProduct.id).then(() => {
      this.items = this.items.filter(p => p.id !== this.selectedProduct.id);
      this.goToPage(this.pageIndex);
      this.showDeleteModal = false;
    });
  }
}
